import React from "react";
import { Select } from "antd";
import { KitchenGroup } from "./KitchenGroupFormModal";

interface KitchenGroupSelectProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
  groups: KitchenGroup[];
  allowClear?: boolean;
  placeholder?: string;
}

const KitchenGroupSelect: React.FC<KitchenGroupSelectProps> = ({
  value,
  onChange,
  groups,
  allowClear = true,
  placeholder = "Select kitchen group",
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      allowClear={allowClear}
      placeholder={placeholder}
      style={{ width: "100%" }}
      options={groups.map((g) => ({
        label: g.name,
        value: g.id,
      }))}
    />
  );
};

export default KitchenGroupSelect;
